import { IpwSystemId, IpwSystemIdKey, ThirdPartySystemId } from '../../third-party-system.enums';

export const PcpartpickerIpwSystemId = IpwSystemId.PCPARTPICKER;
export const PcpartpickerIpwSystemIdKey = IpwSystemIdKey.PCPARTPICKER;
export const PcpartpickerThirdPartySystemId = ThirdPartySystemId.PCPARTPICKER;
